import { render, staticRenderFns } from "./PayFunction.vue?vue&type=template&id=6ba21204&scoped=true&"
import script from "./PayFunction.vue?vue&type=script&lang=js&"
export * from "./PayFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba21204",
  null
  
)

export default component.exports